import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { Input } from "components/shared/FormComponents";
const Blogs = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const {
    reset,
    handleSubmit,
    formState: { errors },
    register,
  } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home-1",
        slug: "blogs",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
  }, [reset, section]);
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    dispatch(
      editSection({
        slug: "blogs",
        page: "home-1",
        data: { section: data },
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"blogs"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                {/* section title */}
                <Row>
                  <Row>
                    <Col lg={6} xs={12}>
                      <Input
                        langId="title"
                        name="sectionTitle.ar"
                        register={register}
                        errors={errors}
                      />
                    </Col>
                    <Col lg={6} xs={12}>
                      <Input
                        langId="title"
                        name="sectionTitle.en"
                        register={register}
                        errors={errors}
                      />
                    </Col>
                  </Row>
                </Row>
                {/* section  sub title */}
                <Row>
                  <Row>
                    <Col lg={6} xs={12}>
                      <Input
                        langId="subTitle"
                        name="sectionSubTitle.ar"
                        register={register}
                        errors={errors}
                      />
                    </Col>
                    <Col lg={6} xs={12}>
                      <Input
                        langId="subTitle"
                        name="sectionSubTitle.en"
                        register={register}
                        errors={errors}
                      />
                    </Col>
                  </Row>
                </Row>
              </Row>
              <SaveChangesButton />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogs;
